import { render, staticRenderFns } from "./blackVehicle.vue?vue&type=template&id=0d87d176"
import script from "./blackVehicle.vue?vue&type=script&lang=js"
export * from "./blackVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports